import { useState } from "react";
import { useLocale } from "../i18n";
import { CommandForm } from "./CommandForm";
import { ReadPanel } from "./ReadPanel";
import type { Context, RecordValue } from "./types";
import "../styles/season-teams.css";

export function EntryCandidates({ context, actorId, revision, canAdmit, onChanged }: {
  context: Context; actorId: string; revision: number; canAdmit: boolean; onChanged: () => void;
}) {
  const { w } = useLocale();
  const [selected, setSelected] = useState<RecordValue>();
  const [locked, setLocked] = useState(false);
  const round = context.unit?.unitKind === "VOTING_ROUND";
  const editable = round && context.unit?.roundState === "DRAFT" && canAdmit && !context.readOnly;
  return <div className="event-season-teams event-entry-candidates">
    {selected ? <div className="event-candidate-editor">
      <button type="button" className="text-button" disabled={locked} onClick={() => setSelected(undefined)}>{w("العودة إلى الفرق القابلة للتسجيل", "Back to eligible teams")}</button>
      <p>{w("الفريق المحدد", "Selected team")}: <strong>{String(selected.name)}</strong></p>
      <CommandForm name="roundEntry" title={w("إدراج الفريق في الجولة", "Admit team to round")} context={context} actorId={actorId}
        fixedQuery={{ partyId: selected.partyId, entryId: "" }} fixedBody={{ included: true }} onLock={setLocked} onCancel={() => setSelected(undefined)}
        onChanged={() => { setSelected(undefined); onChanged(); }} />
    </div> : <ReadPanel name="entryCandidates" title={w("الفرق القابلة للتسجيل", "Eligible teams")} context={context} revision={revision}
      onCandidateSelect={editable ? setSelected : undefined} />}
  </div>;
}
